document.addEventListener("DOMContentLoaded", function () {
  const scrollButtons = document.querySelectorAll(".side-nav-scroll-to-top");
  const tabBlockMain = document.getElementById("tab-block-main");
  scrollButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const topOfTabBlockMain = tabBlockMain.offsetTop;
      window.scrollTo({
        top: topOfTabBlockMain,
        behavior: "smooth",
      });
    });
  });
});
